import { z } from "zod";
import { EscrowStatusSchema } from "@remi/enums/escrow-status";
import { FundingMilestoneScheduleSchema } from "@remi/enums/funding-milestone-schedule";
import { RequestForQuoteStatusSchema } from "@remi/enums/request-for-quote-status";
import { TaskType } from "@remi/enums/task-type";
import { EscrowSchema } from "@remi/types/escrow";
import { FinancingSchema } from "@remi/types/financing";
import { PandadocDocumentSchema } from "@remi/types/pandadocDocument";

export const NoticeToProceedTaskAttemptFormSchema = z.object({
  type: z.literal(TaskType.NOTICE_TO_PROCEED),
});

// No date fields: attempt data round-trips through JSON, which is why the sibling EscrowSchema has
// none either.
const NoticeToProceedAttemptEscrowSchema = z.object({
  id: z.string(),
  externalId: z.string(),
  status: EscrowStatusSchema,
  contractAmount: z.number(),
  fundedAmount: z.number(),
  pendingAmount: z.number(),
  disbursedAmount: z.number(),
  fundingMilestoneSchedule: FundingMilestoneScheduleSchema.nullable(),
});

export const NoticeToProceedTaskAttemptSchema = NoticeToProceedTaskAttemptFormSchema.extend({
  financing: FinancingSchema.nullish(),
  escrow: EscrowSchema.nullish(),
  // Nullish because every attempt row predating this field is re-parsed by the
  // task-attempt-json-data-schema-verification gut check.
  escrows: z.array(NoticeToProceedAttemptEscrowSchema).nullish(),
  pandadocDocument: PandadocDocumentSchema.nullish(),
  requestsForQuote: z.array(
    z.object({
      id: z.number(),
      activeQuoteId: z.string().nullable(),
      activeQuoteVersionId: z.string().nullish(),
      status: RequestForQuoteStatusSchema.nullable(),
      submittedAmount: z.number().nullish(),
      estimatedCostAtNtp: z.number().nullish(),
      estimatedMarginAtNtp: z.number().nullish(),
    }),
  ),
});

export type NoticeToProceedTaskAttempt = z.infer<typeof NoticeToProceedTaskAttemptSchema>;
